<template>
  <div>
    <v-select
      v-model="grade_id"
      class="px-2"
      :items="grades"
      item-text="name"
      item-value="id"
      label="Curso / Ano"
      :disabled="grades.length === 0"
    >
      <template
        v-if="grade_id !== null"
        #append
      >
        <v-btn
          color="primary"
          text
          @click="grade_id = null"
        >
          <v-icon>mdi-delete</v-icon>
        </v-btn>
      </template>
    </v-select>
  </div>
</template>

<script>
import handlesServerValidation from '@/mixins/handles-server-validation.js'
export default {
  mixins: [
    handlesServerValidation
  ],
  props: {
    educationStageId: { type: Number, default: undefined },
    gradeIdSelected: { type: Number, default: undefined }
  },
  data: () => ({
    grades: [],
    grade_id: null
  }),
  watch: {
    grade_id () {
      this.setGrade()
    },
    async educationStageId () {
      if (this.educationStageId) {
        await this.listGrades()
        this.grades.find(grade => grade.id === this.gradeIdSelected) && (this.grade_id = this.gradeIdSelected)
      } else {
        this.grades = []
        this.grade_id = null
        this.setGrade()
      }
    }
  },

  methods: {
    setGrade () {
      this.$emit('setGrade', this.grade_id)
    },
    async listGrades () {
      try {
        this.grades = await this.$api.listGrades(this.educationStageId)
        this.grade_id = null
      } catch (e) {
        this.getErrors(e)
        this.$store.dispatch('setSnackBar', { text: 'Não foi possível obter os cursos, tente novamente mais tarde.', color: 'red' })
      }
    }
  }
}
</script>
